var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<img src="'+
((__t=( model.get('logo_path') ))==null?'':__t)+
'" alt="'+
((__t=( model.get('name') ))==null?'':__t)+
'" style="padding-right: 5px; max-height:33px"/> '+
((__t=( model.get('title') ))==null?'':__t)+
'\n';
}
return __p;
};
